import { render, staticRenderFns } from "./DetailContent.vue?vue&type=template&id=554572bd&scoped=true"
import script from "./DetailContent.vue?vue&type=script&lang=js"
export * from "./DetailContent.vue?vue&type=script&lang=js"
import style0 from "./DetailContent.vue?vue&type=style&index=0&id=554572bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554572bd",
  null
  
)

export default component.exports